import { Component } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import moment from 'moment';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';

import CustomTimePeriod from '../../../../StoryFilters/TimePeriodFilter/CustomTimeFilter/CustomTimePeriod';
import RoundRadioButton from '../../../../GeneralComponents/RoundRadioButton';
import withComponentName from '../../../../../decorators/withComponentName';

import StorageSvc from '../../../../../services/StorageSvc';

import { filterByDate } from '../../../../../actions/filingsFilters.actions';

import Styles from '../styles.module.scss';

import 'react-datepicker/dist/react-datepicker.css';

const cx = classNames.bind(Styles);

export class TimePeriodFilingsFilter extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      width: 0,
      isDatePickerOpen: false,
      startDate: '',
      endDate: '',
      displayedName: '',
      buttonErr: false,
      earliestSearchDate: moment([1, 0, 1]).toDate(),
      minDate: moment([1864, 0, 1]).toDate(),
      dateFilterType: 'lifetime',
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowSizeChange, { passive: true });
    document.addEventListener('click', this.handleClickOutside);
    this.handleWindowSizeChange();

    this.handleWindowSizeChange();
    this.setStateData();
  }

  componentDidUpdate(prevProps) {
    const {
      start_date: propsStartDate, end_date: propsEndDate, filings_time_filter: propsTimeFilterType,
    } = this.props;
    if (
      propsStartDate !== prevProps.start_date
      || propsEndDate !== prevProps.end_date
      || propsTimeFilterType !== prevProps.filings_time_filter
    ) {
      this.setStateData();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
    document.removeEventListener('click', this.handleClickOutside);
  }

  setStateData() {
    const {
      start_date: propsStartDate, end_date: propsEndDate,
      filings_time_filter: propsTimeFilterType, token,
    } = this.props;
    const defaultStartDate = moment().add(-1, 'y').toDate();
    const defaultEndDate = moment().toDate();

    if (!token) {
      const localStoreData = StorageSvc.getItem('FilingsTimeFilter');
      const rehydrate = localStoreData ? JSON.parse(localStoreData) : {};
      const startDate = rehydrate.start_date || defaultStartDate;
      const endDate = rehydrate.end_date || defaultEndDate;
      const displayedName = `${moment(startDate).format('D MMM YYYY')} - ${moment(endDate).format('D MMM YYYY')}`;
      const dateFilterType = rehydrate.filings_time_filter || 'lifetime';
      this.setState({
        startDate,
        endDate,
        displayedName,
        dateFilterType,
      });
    } else {
      const startDate = propsStartDate ? moment(propsStartDate).toDate() : defaultStartDate;
      const endDate = propsEndDate ? moment(propsEndDate).toDate() : defaultEndDate;
      const displayedName = `${moment(startDate).format('D MMM YYYY')} - ${moment(endDate).format('D MMM YYYY')}`;
      this.setState({
        startDate,
        endDate,
        displayedName,
        dateFilterType: propsTimeFilterType,
      });
    }
  }

  setDateFilter({ start_datetime: startDate, end_datetime: endDate }) {
    const { piwikEnabled } = this.props;
    const displayedName = `${moment(startDate).format('D MMM YYYY')} - ${moment(endDate).format('D MMM YYYY')}`;
    if (moment(startDate).format('DD-MM-YYYY') === moment(endDate).format('DD-MM-YYYY')) {
      this.setState({
        startDate: moment(startDate).startOf('day').toISOString(),
        endDate: moment(endDate).endOf('day').toISOString(),
        displayedName,
      });
    } else {
      this.setState({
        startDate,
        endDate,
        displayedName,
      });
    }

    if (piwikEnabled) {
      _paq.push(['trackEvent', 'Filings', `Start date: ${startDate}, end date: ${endDate}`]);
    }
  }

  setViewDateFilter({ type }) {
    this.setState({
      dateFilterType: type,
    });
  }

  handleWindowSizeChange() {
    this.setState({
      width: window.innerWidth,
    });
  }

  handleClickOutside(e) {
    const { isDatePickerOpen } = this.state;
    if (
      this.datePicker && !this.datePicker.contains(e.target)
      && e.target
      && isDatePickerOpen
    ) {
      this.setState({
        isDatePickerOpen: false,
      }, () => {
        this.saveDateFilter();
      });
    }
  }

  handleDatePickerOpenClick() {
    const { isDatePickerOpen } = this.state;
    this.setState({
      isDatePickerOpen: !isDatePickerOpen,
    }, () => {
      const { isDatePickerOpen: isOpen } = this.state;
      if (!isOpen) {
        this.saveDateFilter();
      }
    });
  }

  saveDateFilter() {
    const { startDate, endDate, dateFilterType } = this.state;
    const { filterByDate: propsFilterByDate, token } = this.props;

    if (!token) {
      StorageSvc.setItem('FilingsTimeFilter', JSON.stringify({
        start_date: startDate, end_date: endDate, filings_time_filter: dateFilterType,
      }));
    }
    propsFilterByDate({
      filing_period_start_datetime: startDate,
      filing_period_end_datetime: endDate,
      filings_time_filter: dateFilterType,
    }, token);
  }

  showButtonError(buttonErr) {
    this.setState({ buttonErr });
  }

  render() {
    const {
      width, isDatePickerOpen, displayedName, startDate, endDate,
      buttonErr, earliestSearchDate, minDate, dateFilterType,
    } = this.state;

    const datepickerBoxClass = cx(Styles.datepicker_box, {
      show: isDatePickerOpen,
    });

    const startDatePass = startDate ? moment(startDate).toDate() : '';
    const endDatePass = endDate ? moment(endDate).toDate() : '';

    return (
      <div
        className={cx('filings-filter-btn', 'time-period-wrapper')}
        ref={(ref) => { this.datePicker = ref; }}
      >
        <div className={Styles.datepicker_header} onClick={this.handleDatePickerOpenClick}>
          <div className={Styles.header_holder}>
            <div className={Styles.header_value}>
              {dateFilterType === 'lifetime' ? 'Full Archive' : displayedName}
            </div>
            <div className={Styles.header_label}>Period</div>
          </div>
          <div className={Styles.header_icon}>
            <FontAwesomeIcon icon={isDatePickerOpen ? faChevronUp : faChevronDown} />
          </div>
        </div>
        <div className={datepickerBoxClass}>
          <div className={Styles.box_close}>
            <FontAwesomeIcon icon={faXmark} onClick={this.handleDatePickerOpenClick} />
          </div>
          <div className={Styles.box_period}>Period:</div>
          <div className={Styles.box_lifetime_choice}>
            <RoundRadioButton
              name="Full Archive"
              value="lifetime"
              selectedFilterValue={dateFilterType}
              setValue={this.setViewDateFilter}
              filterItemInfo={{
                type: 'lifetime',
              }}
            />
          </div>
          <div className={Styles.box_custom_choice}>
            <RoundRadioButton
              name="Date Range"
              value="custom"
              selectedFilterValue={dateFilterType}
              setValue={this.setViewDateFilter}
              filterItemInfo={{
                type: 'custom',
              }}
            />
          </div>
          {
            isDatePickerOpen
              ? (
                <CustomTimePeriod
                  hideRoundButton
                  isFilingsPage
                  activeTimeFilter={dateFilterType}
                  selectedFilterValue={{
                    start_datetime: startDatePass,
                    end_datetime: endDatePass,
                  }}
                  width={width}
                  timeInputWrapperClass={cx('time-input-wrapper')}
                  setTimeFilter={this.setDateFilter}
                  showButtonError={this.showButtonError}
                  buttonErr={buttonErr}
                  earliestSearchDate={earliestSearchDate}
                  errorsBlockClass={Styles.custom_errors_blocks}
                  minDate={minDate}
                />
              )
              : null
          }
        </div>
      </div>
    );
  }
}

const mapToStateProps = ({ storyFilters, watchlistReducer }) => ({
  storyFilters,
  start_date: storyFilters.filing_period_start_datetime,
  end_date: storyFilters.filing_period_end_datetime,
  filings_time_filter: storyFilters.filings_time_filter,
  token: watchlistReducer.userToken,
});

const mapToDispatchProps = {
  filterByDate,
};

export default withComponentName(
  connect(mapToStateProps, mapToDispatchProps)(TimePeriodFilingsFilter),
);
